'use strict';

/**
 *
 * @name: ApiMemberSocialFeedService
 *
 */

function ApiMemberSocialFeedService(
  $rootScope,
  $q,
  $http
) {

  'ngInject';

  /**
   *
   * @PUBLIC
   *
   */

  function twitter(userName) {

    return _getFeed('/social-feed/twitter?socialUserName=' + userName + '&limit=2');
  }

  function instagram(userName) {

    return _getFeed('/social-feed/instagram?socialUserName=' + userName);
  }

  /**
   *
   * @PRIVATE
   *
   */

  function _getFeed(link) {

    return $q(function(resolve, reject) {
      $http.get($rootScope.apiUrlBak + link)
        .success(function(data) {
          resolve(data);
        })
        .error(function(data) {
          reject(data);
        });
    });
  }

  return {
    twitter: twitter,
    instagram: instagram
  };
}

export default ApiMemberSocialFeedService;



// WEBPACK FOOTER //
// ./app/components/_api/member-social-feed.service.js